import React from 'react';
import camelCaseRecursive from 'camelcase-keys-recursive';

const OvertimeCompensationShow = props => {
  const { item } = props;
  const {
    createdAt,
    startDate,
    endDate,
    reincorporationDate,
    daysTaken,
    extraHoursTaken,
    translatedStatus,
    observation
  } = camelCaseRecursive(item);

  return (
    <>
      <div className="info-box">
        <p className="info">
          <span>Fecha de Solicitud:</span> {createdAt}
        </p>

        <p className="info">
          <span>Fecha Inicio:</span> {startDate}
        </p>

        <p className="info">
          <span>Fecha Término:</span> {endDate}
        </p>

        <p className="info">
          <span>Fecha de Retorno:</span> {reincorporationDate}
        </p>

        <p className="info">
          <span>Días Tomados:</span> {daysTaken}
        </p>

        <p className="info">
          <span>Horas Extras Utilizadas:</span> {extraHoursTaken}
        </p>

        <p className="info">
          <span>Estado de la Solicitud:</span> {translatedStatus}
        </p>
        {observation && (
          <p className="info">
            <span>Observación:</span> {observation}
          </p>
        )}
      </div>
    </>
  );
};

export default OvertimeCompensationShow;
